import {sessionStore} from "@services/session";
import {observer} from "mobx-react-lite";
import {ReactNode} from "react";

export const AdminComponent = observer(({children}: {children: ReactNode}) => {

    const {role, isAuth} = sessionStore

    if (role === "admin" && isAuth) {
        return children
    }
})